import * as React from 'react';
import {Field, InjectedFormProps} from 'redux-form';
import FieldFormControl from '../../../FieldFormControl';
import {Col, ControlLabel, FormGroup, HelpBlock} from 'react-bootstrap';
import {normalizeCurrency} from '../../../../util/validators';

interface ICheckboxField {
  label: string;
  name: string;
}
interface ICheckboxGroupProps extends InjectedFormProps {
  fields: ICheckboxField[];
  meta ?: {error, touched, submitFailed};
  renderDefinition: any;
}

export class ActivityField extends React.Component<ICheckboxGroupProps> {
  public render() {
    const { meta } = this.props;
    const hasError = meta.submitFailed && meta.error;
    return (
      <div>
        {this.props.fields.map((field, index) => {
          return (
            <FormGroup className="activities" controlId={field.name} key={index}>
              <Col componentClass={ControlLabel} sm={8}>
                {this.props.renderDefinition(field.name)}
                {field.label}
              </Col>
              <Col sm={4} className="activity-fields">
                <Col sm={6}>
                  <Field
                    addOnRight="%"
                    // currency={true}
                    type="inputGroup"
                    name={field.name + '.percent'}
                    component={FieldFormControl}
                    isNumber={true}
                    isFloat={true}
                    // formControlType={'number'}
                  />
                </Col>
                <Col sm={6}>
                  <Field
                    addOn="€"
                    addOnClassName={['secondary']}
                    currency={true}
                    type="inputGroup"
                    name={field.name + '.amount'}
                    normalize={normalizeCurrency}
                    component={FieldFormControl}
                  />
                </Col>
              </Col>
            </FormGroup>
          );
        })}
        {hasError && (<HelpBlock className={'margin-top has-error'}>{meta.error}</HelpBlock>)}
      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/components/ActivitiesField/components/ActivityField/index.tsx